var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292 976L292 1004",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.5,
    cy: 971.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M287.987 971.19C287.987 967.283 291.288 964.117 295.358 964.117C295.943 964.117 296.511 964.184 297.056 964.308C295.742 963.48 294.187 963 292.519 963C287.814 963 284 966.806 284 971.5C284 976.194 287.814 980 292.519 980C294.814 980 296.895 979.093 298.427 977.62C297.492 978.032 296.454 978.263 295.358 978.263C291.288 978.263 287.987 975.096 287.987 971.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.402 970.6L301.37 968.146L299.536 969.719L297.304 969.056L298.112 971.337L296.765 973.381L299.1 973.218L300.499 975.144L301.133 972.763L303.345 971.909L301.402 970.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch7);
export default __webpack_public_path__ + "static/media/church_7.3b96ed848d68209552676e1b68babfe9.svg";
export { ForwardRef as ReactComponent };